import { define } from '../redux-request';
import api from '../../api/api';

export const GET_TEAM = define('GET_TEAM');

export function getTeamRequest(data) {
  return GET_TEAM.request(() => api.getUserList(data));
}

export const SENT_ADD_USER = define('SENT_ADD_USER');

export function sentAddUserRequest(data) {
  return SENT_ADD_USER.request(() => api.sentNewUser(data));
}

export const SENT_EDIT_USER = define('SENT_EDIT_USER');

export function sentEditUserRequest(data) {
  return SENT_EDIT_USER.request(() => api.sentEditUser(data));
}

export const SENT_EDIT_PROFILE_USER = define('SENT_EDIT_PROFILE_USER');

export function sentEditProfileUserRequest(data) {
  return SENT_EDIT_PROFILE_USER.request(() => api.sentEditProfileUser(data));
}

export const GET_REQ_CHANGE_PASSWORD = define('GET_REQ_CHANGE_PASSWORD');

export function getChangePasswordRequest(data) {
  return GET_REQ_CHANGE_PASSWORD.request(() => api.getReqChangePassword(data));
}
